import * as layout from '../../components/markLayout.module.css';
import React from 'react';
import Section from '@hero/ui-kit/layout/Section';
import { MarkPageHeader, MarkEmptyState } from '../../components/MarkLayout';

import usePagerProps from '../../../../hooks/usePagerProps';
import useContacts from '../../api/useContacts';
import useContactSearchParams from '../../hooks/useContactSearchParams';
import ContactSearchBar from './ContactSearchBar';
import ContactList from './ContactList';
import LimitItems from '../../../../components/LimitItems';
import InlineLoader from '../../../../components/InlineLoader';
import QueryInlineError from '../../../../components/QueryInlineError';
const ContactsPage: React.FC = () => {
    const { params } = useContactSearchParams();
    const { data: contactsResponse, isFetching, isLoading, error } = useContacts(params);
    const contacts = contactsResponse?.data?.contacts || [];
    const totalCount = contactsResponse?.data?.total_count || 0;
    const pagerProps = usePagerProps({
        total_count: totalCount,
        limit: params.limit || 20,
        offset: params.offset || 0
    });
    const hasQuery = !!params.q;
    return (
        <Section subtheme={['regular', 'background']} className={layout.page} noDefaultPadding>
            <MarkPageHeader
                title="Contacts"
                description="Find a contact to review audience memberships, campaign activity, and consent status."
            />
            <div className={layout.toolbar}>
                <ContactSearchBar />
            </div>
            {hasQuery && (
                <LimitItems
                    isLoading={isLoading}
                    limit={params.limit}
                    offset={params.offset}
                    total_count={totalCount}
                />
            )}
            {!hasQuery ? (
                <MarkEmptyState
                    title="Find a contact"
                    description="Enter an email, name, or Hero user ID, then select Search."
                />
            ) : error ? (
                <QueryInlineError error={error} />
            ) : isLoading ? (
                <InlineLoader />
            ) : contacts.length === 0 ? (
                <MarkEmptyState
                    title="No matching contacts"
                    description={`No contacts match “${params.q}”. Try another search or change the contact type.`}
                />
            ) : (
                <ContactList contacts={contacts} isLoading={isFetching} pagerProps={pagerProps} />
            )}
        </Section>
    );
};
export default ContactsPage;
